import React, { useEffect, useState } from "react";
import { GoArrowLeft } from "react-icons/go";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import "./globalsearchfilter.scss";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import GlobalsearchContent from "./globalsearchContent";
import dayjs from "dayjs";
import IOSSwitch from "../Iosswitch";
const GlobalSearchfilter = ({
  setClearAll,
  clearAll,
  resetHandler,
  fromTransit = false,
  isOpen,
  setPage,
  photography,
  conservation,
  assign,
  photostatus = false,
  driveUrl = false,
  condition = false,
  iconic = false,
  reference = false,
  update,
  setUpdate,
  setSelectedContents,
  selectedContents,
  selectedFilterOptions,
  setIsOpen,
  formik,
  isClearAll,
  setIsClearAll,
}) => {
  const [showFilterBox, setShowFilterBox] = useState(false);
  const [contentHeader, setContentHeadr] = useState("");
  const [showFilterBoxContent, setshowFilterBoxContent] = useState({
    category: false,
    material: false,
    function: false,
    Inscriptions: false,
    Curatorial: false,
    Objectpriority: false,
    Preliminarycondition: false,
    Orientation: false,
    LastupdatedBy: false,
    Lastupdatedat: false,
    Provenance: false,
    createdDate: false,
    Acquistionmethod: false,
    Currentlocation: false,
    Daetable: false,
    Depth: false,
    width: false,
    Height: false,
    Createdby: false,
    Tags: false,
    Accession: false,
    Referenceimage: false,
    iconic: false,
    room: false,
    driveUrl: false,
    updatedAt: false,
    condition: false,
    photostatus: false,
    remark: false,
  });

  const userData = JSON.parse(localStorage.getItem("user_info"));

  const showContentBoxHandler = (titleValue) => {
    setContentHeadr(titleValue);
    setShowFilterBox(true);
    if (titleValue === "Reference image") {
      setshowFilterBoxContent({
        Referenceimage: true,
      });
    } else if (titleValue === "Accession number") {
      setshowFilterBoxContent({
        Accession: true,
      });
    } else if (titleValue === "Category") {
      setshowFilterBoxContent({
        category: true,
      });
    } else if (titleValue === "Materials") {
      setshowFilterBoxContent({
        material: true,
      });
    } else if (titleValue === "Created by") {
      setshowFilterBoxContent({
        Createdby: true,
      });
    } else if (titleValue === "Height") {
      setshowFilterBoxContent({
        Height: true,
      });
    } else if (titleValue === "Width") {
      setshowFilterBoxContent({
        width: true,
      });
    } else if (titleValue === "Depth") {
      setshowFilterBoxContent({
        Depth: true,
      });
    } else if (titleValue === "Datable time period") {
      setshowFilterBoxContent({
        Daetable: true,
      });
    } else if (titleValue === "Acquisition method") {
      setshowFilterBoxContent({
        Acquistionmethod: true,
      });
    } else if (titleValue === "Created date") {
      setshowFilterBoxContent({
        createdDate: true,
      });
    } else if (titleValue === "Iconic object") {
      setshowFilterBoxContent({
        iconic: true,
      });
    } else if (titleValue === "Room") {
      setshowFilterBoxContent({
        room: true,
      });
    } else if (titleValue === "Tags") {
      setshowFilterBoxContent({
        Tags: true,
      });
    } else if (titleValue === "Last updated") {
      setshowFilterBoxContent({
        updatedAt: true,
      });
    } else if (titleValue === "Condition grading") {
      setshowFilterBoxContent({
        condition: true,
      });
    } else if (titleValue === "Drive url") {
      setshowFilterBoxContent({
        driveUrl: true,
      });
    } else if (titleValue === "Digital image status") {
      setshowFilterBoxContent({
        photostatus: true,
      });
    } else if (titleValue === "Remark") {
      setshowFilterBoxContent({
        remark: true,
      });
    }
  };

  const onBackToFilter = (deleteValue, selectedFormikDatas) => {
    setShowFilterBox(false);
    if (selectedFormikDatas) {
      formik?.setValues(selectedFormikDatas);
    }
  };

  const assignedChangeHandler = (e) => {
    if (e?.target?.checked) {
      formik?.setValues({
        ...formik.values,
        object_assigned: userData?.id,
      });
      const filterValue = {
        title: "Assigned to me",
        value: "Assigned to me",
      };
      setSelectedContents((prev) => {
        // Check if an item with the same title exists
        const exists = prev.some((item) => item.title === filterValue.title);

        if (exists) {
          // Replace the existing element
          return prev.map((item) =>
            item.title === filterValue.title ? filterValue : item
          );
        }

        // If it doesn't exist, add the new filtered value
        return [...prev, filterValue];
      });
      setUpdate(!update);
      formik.handleSubmit();
    } else {
      formik?.setValues({
        ...formik?.values,
        object_assigned: "",
      });

      setSelectedContents((prev) =>
        prev.filter((item) => item.title !== "Assigned to me")
      );
      setUpdate(!update);
      formik.handleSubmit();
    }
  };

  const discardGlobal = () => {
    if (fromTransit) {
      resetHandler();
    } else {
      setUpdate(!update);
      setSelectedContents([]);
      formik?.resetForm();
    }
    // setIsOpen(false)
  };

  useEffect(() => {
    // When drawer opens
    // const originalOverflow = document.body.style.overflow;

    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      // Ensure scroll is restored when component unmounts
      document.body.style.overflow = "auto";
    };
    // When drawer closes / unmounts
  }, [isOpen, showFilterBox]);
  return (
    <div className="global-filter-container">
      {showFilterBox ? (
        <GlobalsearchContent
          isClearAll={isClearAll}
          setIsClearAll={setIsClearAll}
          isOpen={isOpen}
          setPage={setPage}
          setUpdate={setUpdate}
          update={update}
          setShowFilterBox={setShowFilterBox}
          formik={formik}
          selectedContents={selectedContents}
          setSelectedContents={setSelectedContents}
          contentHeader={contentHeader}
          onBackToFilter={onBackToFilter}
          showFilterBoxContent={showFilterBoxContent}
        />
      ) : (
        <Form onSubmit={formik?.handleSubmit}>
          <div className="filter-header">
            <GoArrowLeft onClick={() => setIsOpen(false)} />
            <h4>Filter</h4>
          </div>
          <div>
            <div className="filter-content-container">
              {assign && (
                <div className="filter-content-options">
                  <p>Assigned to me</p>
                  <IOSSwitch
                    onChange={assignedChangeHandler}
                    checked={formik?.values?.object_assigned}
                  />
                </div>
              )}

              {iconic && (
                <div
                  onClick={() => showContentBoxHandler("Iconic object")}
                  className="filter-content-options"
                >
                  <div>
                    <p>Iconic object</p>
                    {(formik?.values?.hasIconic ||
                      formik?.values?.hasNoIconic) && (
                      <span style={{ color: "#8e8888", fontSize: "12px" }}>
                        {formik?.values?.hasIconic
                          ? "Iconic object"
                          : "Non iconic objects"}
                      </span>
                    )}
                  </div>
                  <MdOutlineKeyboardArrowRight />
                </div>
              )}
              {reference && (
                <div
                  onClick={() => showContentBoxHandler("Reference image")}
                  className="filter-content-options"
                >
                  <div>
                    <p>Reference image</p>
                    {(formik?.values?.hasImage ||
                      formik?.values?.hasNoImage) && (
                      <span style={{ color: "#8e8888", fontSize: "12px" }}>
                        {formik?.values?.hasImage
                          ? "Has reference image"
                          : "No reference image"}
                      </span>
                    )}
                  </div>
                  <MdOutlineKeyboardArrowRight />
                </div>
              )}
              {!fromTransit && (
                <div
                  onClick={() => showContentBoxHandler("Category")}
                  className="filter-content-options"
                >
                  <div>
                    <p>Category</p>
                    <span style={{ color: "#8e8888", fontSize: "12px" }}>
                      {formik?.values?.selectedCategory?.length
                        ? formik.values.selectedCategory
                            .map((cat) => {
                              const subsForCat =
                                formik.values.selctedSubCategory?.filter(
                                  (sub) => sub.primary_category === cat.value
                                ) || [];
                              return subsForCat.length
                                ? `${cat.label} - ${subsForCat
                                    .map((s) => s.label)
                                    .join(", ")}`
                                : cat.label;
                            })
                            .join(", ")
                        : ""}
                    </span>
                  </div>
                  <MdOutlineKeyboardArrowRight />
                </div>
              )}
              <div
                onClick={() => showContentBoxHandler("Materials")}
                className="filter-content-options"
              >
                <div>
                  <p>Materials</p>
                  <span style={{ color: "#8e8888", fontSize: "12px" }}>
                    {formik?.values?.selectedMaterial
                      ?.map(
                        (li, index) =>
                          `${li?.label}${
                            index !==
                            formik?.values?.selectedMaterial?.length - 1
                              ? ", "
                              : ""
                          }`
                      )
                      .join("")}
                  </span>{" "}
                </div>
                <MdOutlineKeyboardArrowRight />
              </div>
              {!fromTransit && (
                <div
                  onClick={() => showContentBoxHandler("Room")}
                  className="filter-content-options"
                >
                  <div>
                    <p>Room</p>
                    <div>
                      {/* Original Location */}
                      {formik.values.selectedRoom?.length > 0 && (
                        <div style={{ marginBottom: "8px" }}>
                          <span style={{ fontWeight: "600" }}>
                            Original location:
                          </span>
                          <span
                            style={{
                              color: "#8e8888",
                              fontSize: "12px",
                              marginLeft: "4px",
                            }}
                          >
                            {formik.values.selectedRoom.join(", ")}
                          </span>
                        </div>
                      )}

                      {/* Transit Location */}
                      {formik.values.selectedTransitRoom?.length > 0 && (
                        <div>
                          <span style={{ fontWeight: "600" }}>
                            Transit location:
                          </span>
                          <span
                            style={{
                              color: "#8e8888",
                              fontSize: "12px",
                              marginLeft: "4px",
                            }}
                          >
                            {formik.values.selectedTransitRoom.join(", ")}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                  <MdOutlineKeyboardArrowRight />
                </div>
              )}
              <div
                onClick={() => showContentBoxHandler("Tags")}
                className="filter-content-options"
              >
                <div>
                  <div>
                    <p>Tags</p>
                    {formik?.values?.tags && (
                      <span style={{ color: "#8e8888", fontSize: "12px" }}>
                        {formik?.values?.tags}
                      </span>
                    )}
                  </div>
                </div>
                <MdOutlineKeyboardArrowRight />
              </div>
              {/* {driveUrl &&
                                <div onClick={() => showContentBoxHandler("Drive url")} className='filter-content-options'>
                                    <div>
                                        <p>Drive url</p>
                                        {(formik?.values?.hasDrive || formik?.values?.hasNoDrive) && (
                                            <span style={{ color: "#8e8888", fontSize: "12px" }}>
                                                {formik?.values?.hasDrive ? "Drive url" : "No drive url"}
                                            </span>
                                        )}
                                    </div>
                                    <MdOutlineKeyboardArrowRight />
                                </div>
                            } */}
              {photostatus && (
                <div
                  onClick={() => showContentBoxHandler("Digital image status")}
                  className="filter-content-options"
                >
                  <div>
                    <p>Digital image status</p>
                    {formik?.values?.photography_status && (
                      <span style={{ color: "#8e8888", fontSize: "12px" }}>
                        {(formik?.values?.photography_status === "to_do" &&
                          "To do") ||
                          (formik?.values?.photography_status ===
                            "in_photography" &&
                            "In photography") ||
                          (formik?.values?.photography_status ===
                            "photography_complete" &&
                            "Photography complete") ||
                          (formik?.values?.photography_status === "re_shoot" &&
                            "Reshoot")}
                      </span>
                    )}
                  </div>
                  <MdOutlineKeyboardArrowRight />
                </div>
              )}

              {condition && (
                <div
                  onClick={() => showContentBoxHandler("Condition grading")}
                  className="filter-content-options"
                >
                  <div>
                    <div>
                      <p>Condition grading</p>

                      {(formik?.values?.conservation_grade?.length > 0 ||
                        formik?.values?.is_emergency) && (
                        <span style={{ color: "#8e8888", fontSize: "12px" }}>
                          {[
                            ...(formik?.values?.conservation_grade || []).map(
                              (g) =>
                                g === "blank" ? "No condition grading" : g
                            ),
                            ...(formik?.values?.is_emergency
                              ? ["Emergency"]
                              : []),
                          ].join(", ")}
                        </span>
                      )}
                    </div>
                  </div>
                  <MdOutlineKeyboardArrowRight />
                </div>
              )}

              {condition && (
                <div
                  onClick={() => showContentBoxHandler("Remark")}
                  className="filter-content-options"
                >
                  <div>
                    <p>Remark</p>
                    {(formik?.values?.hasRemark ||
                      formik?.values?.hasNoRemark) && (
                      <span style={{ color: "#8e8888", fontSize: "12px" }}>
                        {formik?.values?.hasRemark ? "Has remark" : "No remark"}
                      </span>
                    )}
                  </div>
                  <MdOutlineKeyboardArrowRight />
                </div>
              )}
              <div
                onClick={() => showContentBoxHandler("Created by")}
                className="filter-content-options"
              >
                <div>
                  <div>
                    <p>Created by</p>
                    {formik?.values?.created_by && (
                      <span style={{ color: "#8e8888", fontSize: "12px" }}>
                        {formik?.values?.selectedUser?.length
                          ? formik.values.selectedUser.join(", ")
                          : ""}
                      </span>
                    )}
                  </div>
                </div>
                <MdOutlineKeyboardArrowRight />
              </div>
              <div
                onClick={() => showContentBoxHandler("Created date")}
                className="filter-content-options"
              >
                <div>
                  <p>Created date</p>
                  {(formik?.values?.start_date || formik?.values?.end_date) && (
                    <span
                      style={{ color: "#8e8888", fontSize: "12px" }}
                    >{`${dayjs(formik?.values?.start_date, "D-M-YYYY").format(
                      "DD-MMM-YYYY"
                    )} - ${dayjs(formik?.values?.end_date, "D-M-YYYY").format(
                      "DD-MMM-YYYY"
                    )} `}</span>
                  )}
                </div>
                <MdOutlineKeyboardArrowRight />
              </div>
              <div
                onClick={() => showContentBoxHandler("Last updated")}
                className="filter-content-options"
              >
                <div>
                  <p>Last updated</p>
                  {(formik?.values?.modified_start_date ||
                    formik?.values?.modified_end_date) && (
                    <span
                      style={{ color: "#8e8888", fontSize: "12px" }}
                    >{`${dayjs(
                      formik?.values?.modified_start_date,
                      "D-M-YYYY"
                    ).format("DD-MMM-YYYY")} - ${dayjs(
                      formik?.values?.modified_end_date,
                      "D-M-YYYY"
                    ).format("DD-MMM-YYYY")} `}</span>
                  )}
                </div>
                <MdOutlineKeyboardArrowRight />
              </div>
              <div
                onClick={() => showContentBoxHandler("Height")}
                className="filter-content-options"
              >
                <div>
                  <p>Height in cm</p>
                  {(formik?.values?.height_min ||
                    formik?.values?.height_max) && (
                    <span
                      style={{ color: "#8e8888", fontSize: "12px" }}
                    >{`${formik?.values?.height_min} - ${formik?.values?.height_max} (cm)`}</span>
                  )}
                </div>
                <MdOutlineKeyboardArrowRight />
              </div>
              <div
                onClick={() => showContentBoxHandler("Width")}
                className="filter-content-options"
              >
                <div>
                  <p>Width in cm</p>
                  {(formik?.values?.width_min || formik?.values?.width_max) && (
                    <span
                      style={{ color: "#8e8888", fontSize: "12px" }}
                    >{`${formik?.values?.width_min} - ${formik?.values?.width_max} (cm)`}</span>
                  )}
                </div>
                <MdOutlineKeyboardArrowRight />
              </div>
              <div
                onClick={() => showContentBoxHandler("Depth")}
                className="filter-content-options"
              >
                <div>
                  <p>Depth in cm</p>
                  {(formik?.values?.depth_min || formik?.values?.depth_max) && (
                    <span
                      style={{ color: "#8e8888", fontSize: "12px" }}
                    >{`${formik?.values?.depth_min} - ${formik?.values?.depth_max} (cm)`}</span>
                  )}
                </div>
                <MdOutlineKeyboardArrowRight />
              </div>
              <div
                onClick={() => showContentBoxHandler("Datable time period")}
                className="filter-content-options"
              >
                <div>
                  <p>Datable time period</p>
                  {(formik?.values?.period_start ||
                    formik?.values?.period_end) && (
                    <span
                      style={{ color: "#8e8888", fontSize: "12px" }}
                    >{`${formik?.values?.period} ${formik?.values?.period_start} - ${formik?.values?.period_end}`}</span>
                  )}
                </div>
                <MdOutlineKeyboardArrowRight />
              </div>
              <div
                onClick={() => showContentBoxHandler("Acquisition method")}
                className="filter-content-options"
              >
                <div>
                  <p>Acquisition method</p>
                  <span style={{ color: "#8e8888", fontSize: "12px" }}>
                    {formik?.values?.acquisition_method?.length
                      ? formik.values.acquisition_method.join(", ")
                      : ""}
                  </span>
                </div>
                <MdOutlineKeyboardArrowRight />
              </div>
            </div>

            <div
              className="submit-btn-row global-search-button"
              style={{ justifyContent: "flex-start" }}
            >
              <Button
                style={{ marginLeft: "27px" }}
                onClick={discardGlobal}
                className="submit-btn"
                type="button"
              >
                Reset
              </Button>
              {/* <Button className="submit-btn" type="submit" >
                                Filter
                            </Button> */}
            </div>
          </div>
        </Form>
      )}
    </div>
  );
};

export default GlobalSearchfilter;
